/* import __COLOCATED_TEMPLATE__ from './about.hbs'; */
import Component from '@glimmer/component';
import Constants from '../../utils/constants';

export default class AboutModal extends Component {
  get modalType() {
    return Constants.MODAL_TYPES.ABOUT.value;
  }
}
